import { LayoutConfig, StoreUIMenu } from '@insite-store360/shared';

function hasCountryAccess(itemCountryIds: number[] | undefined, allowedCountryIds: number[]): boolean {
  if (!itemCountryIds || itemCountryIds.length === 0) return true;
  if (!allowedCountryIds || allowedCountryIds.length === 0) return false;
  return itemCountryIds.some((id) => allowedCountryIds.includes(id));
}

function applyCountryVisibilityToMenu(menu: StoreUIMenu[], allowedCountryIds: number[]): StoreUIMenu[] {
  return menu
    .map((item) => {
      const subMenu = item.subMenu
        ? applyCountryVisibilityToMenu(item.subMenu, allowedCountryIds)
        : undefined;
      const selfVisible = hasCountryAccess(item.countryIds, allowedCountryIds);
      const childVisible = !!subMenu?.some((child) => child.visible !== false);
      // Keep parent groups when any child remains visible so country-restricted
      // parents do not hide unrestricted children.
      const visible = subMenu?.length ? childVisible : selfVisible;
      return { ...item, subMenu, visible };
    })
    .filter((item) => item.visible !== false);
}

export function applyCountryVisibility(layoutConfig: LayoutConfig, allowedCountryIds: number[]): LayoutConfig {
  const menu = layoutConfig.sideNavConfig.menu || [];
  return {
    ...layoutConfig,
    sideNavConfig: {
      ...layoutConfig.sideNavConfig,
      menu: applyCountryVisibilityToMenu(menu, allowedCountryIds),
    },
  };
}

